import { useEffect, useState } from "react";
import siteSettingsService from "../services/siteSettingsService";

// Same default the rate held as a hardcoded constant before this became
// configurable (Settings → Accounting Setup) — used while the fetch is in
// flight and as a last resort if it fails, so a slow/broken network never
// breaks the Daily Cash Flow tool's math, just leaves the rate stale.
const DEFAULT_COD_FEE_RATE = 0.01;
const SETTING_KEY = "cod_fee_rate";

let cache: number | null = null;
let inflight: Promise<number> | null = null;

function fetchRate(): Promise<number> {
    if (cache !== null) return Promise.resolve(cache);
    if (!inflight) {
        inflight = siteSettingsService
            .getByKey(SETTING_KEY)
            .then((setting) => {
                const parsed = parseFloat(setting.value ?? "");
                const rate = Number.isFinite(parsed) ? parsed : DEFAULT_COD_FEE_RATE;
                cache = rate;
                return rate;
            })
            .catch(() => DEFAULT_COD_FEE_RATE)
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
}

export function useCodFeeRate(): number {
    const [rate, setRate] = useState<number>(cache ?? DEFAULT_COD_FEE_RATE);

    useEffect(() => {
        if (cache !== null) return;
        let cancelled = false;
        fetchRate().then((value) => {
            if (!cancelled) setRate(value);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return rate;
}
